module.exports = __webpack_public_path__ + "static/media/Shuffle Song (1).ea715f27.svg";